import React, { FC } from 'react'

import { InterSvgIcon } from 'components'
import { HelpCenterBottomSheet } from 'components/help-center-bottomsheet'

import { ButtonText, HelpCenterButtonContainer } from '../styles/HelpCenterButton.styles'
import { THelpCenterButtonView } from '../types/HelpCenterButton.types'

export const HelpCenterButtonView: FC<THelpCenterButtonView> = ({
  icon,
  buttonText,
  showBottomSheet,
  onClick,
}) => {
  const handleButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.currentTarget.blur()
    onClick()
  }

  return (
    <>
      <HelpCenterButtonContainer onClick={handleButtonClick}>
        <InterSvgIcon iconRef={icon} width={24} height={24} color="var(--secondary500)" />
        <ButtonText variant="body-3" color="typography" colorWeight={500} as="p" semiBold>
          {buttonText}
        </ButtonText>
        <InterSvgIcon
          iconRef="core/action-navigation/ic_chevron_right"
          height={24}
          width={24}
          color="var(--secondary500)"
        />
      </HelpCenterButtonContainer>
      {showBottomSheet && <HelpCenterBottomSheet onClose={onClick} />}
    </>
  )
}
